import React from 'react';
// import { Container } from '@material-ui/core';
import { withRouter } from 'react-router'; // import the react-router-dom components
import LanguageDropdown from '../../components/app_common/language_dropdown';
import LoginForm from './components/login_form';
import useStyles from './styles';
import { showToastAction } from '../../components/atoms/toast_message';
import { useDispatch } from 'react-redux';
import useQuery from '../../custom_hooks/useQuery';
interface IProps {}

const LoginPage: React.FC<IProps> = (props) => {
  // console.log('Render LoginPage');
  const classes = useStyles();
  const dispatch = useDispatch();
  const query = useQuery();
  if (query.get('verified') === 'true') {
    showToastAction(dispatch, 'Your account has been verified', 'success');
  } else if (query.get('verified') === 'false') {
    showToastAction(
      dispatch,
      'Something went wrong while verifying your account. Please contact administrator',
      'error'
    );
  }
  return (
    <div>
      <div className={classes.languageButton}>
        <LanguageDropdown />
      </div>
      <LoginForm />
    </div>
  );
};

export default withRouter(LoginPage);
